import React from "react";
import "../../CSS/Industries.css";

function Manufacturing() {
    return (
        <>
           
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">


                        <h1>
                            Solutions for Manufacturing
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Build digital systems that help manufacturing
                            businesses manage production, inventory,
                            operations, and business processes.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Digital Solutions for Manufacturing Businesses
                            </h2>

                            <p>
                                Manufacturing companies manage complex
                                processes involving production, inventory,
                                employees, suppliers, and customers.
                            </p>

                            <p>
                                We develop customized software and business
                                applications that help organize these
                                processes.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/manufacturing.png"
                                alt="Manufacturing Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Manufacturing</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-gear"></i>
                            <h3>Production Management</h3>
                            <p>Software solutions for managing production processes.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-boxes"></i>
                            <h3>Inventory Management</h3>
                            <p>Systems to organize and manage inventory information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-clipboard-data"></i>
                            <h3>Business Reports</h3>
                            <p>Reporting systems for operational and business information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-diagram-3"></i>
                            <h3>Workflow Management</h3>
                            <p>Digital workflows for manufacturing business processes.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Manufacturing;